import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';
import { Button } from 'fe-appdir-comp-button';

const PROP_TYPES = {
  name: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  graphic: PropTypes.func.isRequired,
  developer: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  gaTrackId: PropTypes.string,
  gaTrackInfo: PropTypes.string,
};

const DEFAULT_PROPS = {
  buttonLabel: 'Learn More',
}

/**
 * Truncates a string to a character length and adds an optional suffix
 *
 * @param {string} str - string to be truncated
 * @param {string} length - desired length of string
 * @param {string} suffix - an optional string suffix to append
 */
const truncate = (str = '', length = 0, suffix = '') =>
  str.length > length ? `${str.substring(0, length)}${suffix}` : str;

const Container = styled.section`
  padding: ${theme.spacingXl};
  padding-bottom: ${theme.spacingXxl};
  background: ${theme.colorWhite};
  box-shadow: 0 5px 18px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: ${theme.fontFamilyPrimary};

  @media (max-width: ${theme.breakpointMd}) {
    margin: ${theme.spacingMd} 0;
  }

  @media (min-width: ${theme.breakpointMd}) {
    flex-basis: calc(2 / 3 * 100%);
    margin-right: ${theme.spacingMd};
  }
`;

const H1 = styled.h1`
  margin: 0;
  font-size: 30px;
  font-weight: ${theme.fontWeightSemibold};
`;

const H2 = styled.h2`
  margin: ${theme.spacingSm} 0;
  font-size: ${theme.fontSizeSm};
  font-weight: ${theme.fontWeightNormal};
  color: ${theme.colorBase};
`;

const GraphicWrapper = styled.div`
  margin: ${`${theme.spacingLg} ${theme.spacingLg} ${theme.spacingXl}`};
`;

const P = styled.p`
  margin: ${theme.spacingLg} auto;
  padding: 0 ${theme.spacingSm};
  color: ${theme.colorBase};
  font-size: ${theme.fontSizeMd};
  line-height: 1.5;
`;

const AppSummary = ({ name, buttonLabel, graphic, developer, description, onClick, gaTrackId, gaTrackInfo }) => (
  <Container>
    <H1>{name}</H1>
    <GraphicWrapper>{graphic()}</GraphicWrapper>
    <H2>
      By <strong>{developer}</strong>
    </H2>
    <P>{truncate(description, 330, '...')}</P>
    <Button onClick={onClick} gaTrackId={gaTrackId} gaTrackInfo={gaTrackInfo}>{buttonLabel}</Button>
  </Container>
);

AppSummary.propTypes = PROP_TYPES;
AppSummary.defaultProps = DEFAULT_PROPS;
AppSummary.displayName = 'AppSummary';

export default AppSummary;
